import { useEffect, useState } from 'react';
import { FormRow, Alert } from '../../components';
import { useGlobalContext } from '../../context/GlobalContext';
import styled from 'styled-components';

const Profile = () => {
  const { user, showAlert, displayAlert, updateUser, isLoading } =
    useGlobalContext();
  const [name, setName] = useState(user?.name);
  const [email, setEmail] = useState(user?.email);
  const [address1, setAddress1] = useState(user?.address1);
  const [address2, setAddress2] = useState(user?.address2);
  const [phone, setPhone] = useState(user?.phone);

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, address1, address2, phone } = user;
    if (!name || !email || !address1 || !address2 || !phone) {
      displayAlert();
      return;
    }
    updateUser({ name, email, address1, address2, phone });
  };

  return (
    <ProfileContainer>
      <form className='form' onSubmit={handleSubmit}>
        <h3>profile</h3>
        {showAlert && <Alert />}
        <div className='form-center'>
          <FormRow
            type='text'
            name='name'
            value={name}
            handleChange={(e) => setName(e.target.value)}
          />
          <FormRow
            type='email'
            name='email'
            value={email}
            handleChange={(e) => setEmail(e.target.value)}
          />
          <FormRow
            type='text'
            name='address1'
            value={address1}
            handleChange={(e) => setAddress1(e.target.value)}
          />
          <FormRow
            type='text'
            name='address2'
            value={address2}
            handleChange={(e) => setAddress2(e.target.value)}
          />
          <FormRow
            type='text'
            name='phone'
            value={phone}
            handleChange={(e) => setPhone(e.target.value)}
          />
          <button className='btn btn-block' type='submit' disabled={isLoading}>
            {isLoading ? 'Please Wait...' : 'save changes'}
          </button>
        </div>
      </form>
    </ProfileContainer>
  );
};

const ProfileContainer = styled.section`
  border-radius: var(--borderRadius);
  width: 100%;
  background: var(--white);
  padding: 3rem 2rem 4rem;
  box-shadow: var(--shadow-2);
  h3 {
    margin-top: 0;
  }
  .form {
    margin: 0;
    border-radius: 0;
    box-shadow: none;
    padding: 0;
    max-width: 100%;
    width: 100%;
  }
  .form-row {
    margin-bottom: 0;
  }
  .form-center {
    display: grid;
    row-gap: 0.5rem;
  }
  .form-center button {
    align-self: end;
    height: 35px;
    margin-top: 1rem;
  }
  .btn-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 1rem;
    align-self: flex-end;
    margin-top: 0.5rem;
    button {
      height: 35px;
    }
  }
  .clear-btn {
    background: var(--grey-500);
  }
  .clear-btn:hover {
    background: var(--black);
  }
  @media (min-width: 992px) {
    .form-center {
      grid-template-columns: 1fr 1fr;
      align-items: center;
      column-gap: 1rem;
    }
    .btn-container {
      margin-top: 0;
    }
  }
  @media (min-width: 1120px) {
    .form-center {
      grid-template-columns: 1fr 1fr 1fr;
    }
    .form-center button {
      margin-top: 0;
    }
  }
`;

export default Profile;
